export const isRequired = (value, field = 'Field') => {
  return value == null || String(value).trim() === '' ? `${field} is required` : null;
};

export const minLength = (value, length = 3, field = 'Field') => {
  return value.length < length
    ? `${field} must be at least ${length} characters`
    : null;
};

export const isEmail = (value, field = 'Email') => {
   if (!value) return null;
  const pattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+$/;
  return !pattern.test(value) ? `Enter Valid ${field}` : null;
};

export const validateForm = (fields) => {
  const errors = [];

  for (const fieldName in fields) {
    const { value, validators } = fields[fieldName];

    for (const validator of validators) {
      const error = validator(value, fieldName);
      if (error) {
        errors.push(error);
      }
    }
  }

  return errors;
};
